"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirebaseAuthService = void 0;
const firebase = __importStar(require("firebase/app"));
require("firebase/auth");
class FirebaseAuthService {
    constructor(firebaseConfig) {
        firebase.initializeApp(firebaseConfig);
    }
    static getInstance(firebaseConfig) {
        if (!FirebaseAuthService.instance) {
            FirebaseAuthService.instance = new FirebaseAuthService(firebaseConfig);
        }
        return FirebaseAuthService.instance;
    }
    registerUser(email, password) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield firebase.auth().createUserWithEmailAndPassword(email, password);
            }
            catch (err) {
                throw Error(err.message || "Something went wrong during registration.");
            }
        });
    }
    loginWithEmail(email, password) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield firebase.auth().signInWithEmailAndPassword(email, password);
            }
            catch (err) {
                let errorMessage;
                switch (err.code) {
                    case "auth/invalid-email":
                        errorMessage = "Invalid email address.";
                        break;
                    case "auth/user-disabled":
                        errorMessage = "User is disabled.";
                        break;
                    case "auth/user-not-found":
                        errorMessage = "User doesn't exist.";
                        break;
                    case "auth/wrong-password":
                        errorMessage = "Password is incorrect.";
                        break;
                    default:
                        errorMessage = "Something went wrong during login.";
                }
                throw Error(errorMessage);
            }
        });
    }
    signInWithCustomToken(token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield firebase.auth().signInWithCustomToken(token);
            }
            catch (err) {
                throw Error(err.message || "Something went wrong.");
            }
        });
    }
    loginWithGoogle() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const provider = new firebase.auth.GoogleAuthProvider();
                return yield firebase.auth().signInWithPopup(provider);
            }
            catch (err) {
                throw Error(err.message || "Something went wrong during login with google.");
            }
        });
    }
    currentUser() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                try {
                    firebase.auth().onAuthStateChanged((user) => {
                        resolve(user);
                    });
                }
                catch (err) {
                    reject(new Error(err.message || "Something went wrong during user login status check."));
                }
            });
        });
    }
    getIdToken(forceRefresh) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const currentUser = yield this.currentUser();
                if (currentUser) {
                    return yield currentUser.getIdToken(forceRefresh);
                }
                return null;
            }
            catch (err) {
                throw Error(err.message || "Something went wrong during token refetch.");
            }
        });
    }
    signOut() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield firebase.auth().signOut();
            }
            catch (err) {
                throw Error(err.message || "Something went wrong during signOut.");
            }
        });
    }
    onAuthStateChanged(callback) {
        return __awaiter(this, void 0, void 0, function* () {
            firebase.auth().onAuthStateChanged(callback);
        });
    }
}
exports.FirebaseAuthService = FirebaseAuthService;
//# sourceMappingURL=FirebaseAuthService.js.map